export default "assets/images/icons/slider-arrow-345499bb.svg";